
import './FlyerEditorLeftMenu.scss'
import {ReactComponent as PlusIcon} from "../../../../assets/promos&items/icon_plus.svg";
import {ClickMenu} from "../../../../com/clickMenu/clickMenu";
import React, {useRef, useState} from "react";
import {ItemsListMenuDto, UserDto} from "../../../../dtos";
import {MENU_LIST_FRAME_ITEMS} from "../../../../globals/Contants";
import styles from './FrameLeftMenu.module.scss'
import {Button} from "@mui/material";


interface IFlyerEditorLeftMenu {
    onSpotsFileSelected: (file: File) => void,
}

export const FlyerEditorLeftMenu: React.FC<IFlyerEditorLeftMenu> = (props) => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    let userDtoStr = localStorage.getItem('userDto');
    // const isUserViewer = false;
    let isUserViewer = true;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
    }


    const clickMenuData: ItemsListMenuDto = {
        setOpen: setOpen,
        prevOpen: prevOpen,
        open: open,
        anchorRef: anchorRef,
        menuList: MENU_LIST_FRAME_ITEMS
    }


    return (
        <div className={styles.flyers_frames_editor_left_menu}>
            <div className={`${styles.row}`}>
                <div className={`${styles.current_promos}`}>
                    <div className={styles.promos_items_name}>
                        FRAMES
                    </div>

                    <Button
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        disabled={isUserViewer}
                        sx={{
                            ':disabled': {
                                opacity: "0.3"
                            }
                        }}
                        onClick={handleToggle}
                    >
                        <PlusIcon/>
                    </Button>

                    <ClickMenu list={clickMenuData}/>
                </div>
            </div>
            <hr />
        </div>
    )
}